import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { SharedModule } from '@app/sharedModule/shared.module';
import { TrackRoutingModule } from './track-routing.module';
import { TrackComponent } from './track.component';
import { MatDividerModule } from '@angular/material/divider';
import { PreviewModule } from '@app/pages/workspace/verify/preview.module';
import { StorybookModule } from '@storybook/storybook.module';

@NgModule({
  declarations: [TrackComponent],
  imports: [CommonModule, SharedModule, TrackRoutingModule, MatDividerModule, PreviewModule, StorybookModule],
  providers: [Location, { provide: LocationStrategy, useClass: PathLocationStrategy }],
})
export class TrackModule {}
